/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CognitoAuthenticationResultNewDeviceMetadata } from './CognitoAuthenticationResultNewDeviceMetadata';
import {
    CognitoAuthenticationResultNewDeviceMetadataFromJSON,
    CognitoAuthenticationResultNewDeviceMetadataFromJSONTyped,
    CognitoAuthenticationResultNewDeviceMetadataToJSON,
} from './CognitoAuthenticationResultNewDeviceMetadata';

/**
 * Cognito Authentication Result
 * @export
 * @interface CognitoAuthenticationResult
 */
export interface CognitoAuthenticationResult {
    /**
     * Access Token
     * @type {string}
     * @memberof CognitoAuthenticationResult
     */
    accessToken?: string;
    /**
     * Expires In
     * @type {number}
     * @memberof CognitoAuthenticationResult
     */
    expiresIn?: number;
    /**
     * Token Type
     * @type {string}
     * @memberof CognitoAuthenticationResult
     */
    tokenType?: string;
    /**
     * Refresh Token
     * @type {string}
     * @memberof CognitoAuthenticationResult
     */
    refreshToken?: string;
    /**
     * ID Token
     * @type {string}
     * @memberof CognitoAuthenticationResult
     */
    idToken?: string;
    /**
     * 
     * @type {CognitoAuthenticationResultNewDeviceMetadata}
     * @memberof CognitoAuthenticationResult
     */
    newDeviceMetadata?: CognitoAuthenticationResultNewDeviceMetadata;
}

/**
 * Check if a given object implements the CognitoAuthenticationResult interface.
 */
export function instanceOfCognitoAuthenticationResult(value: object): value is CognitoAuthenticationResult {
    return true;
}

export function CognitoAuthenticationResultFromJSON(json: any): CognitoAuthenticationResult {
    return CognitoAuthenticationResultFromJSONTyped(json, false);
}

export function CognitoAuthenticationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CognitoAuthenticationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
        'expiresIn': json['expiresIn'] == null ? undefined : json['expiresIn'],
        'tokenType': json['tokenType'] == null ? undefined : json['tokenType'],
        'refreshToken': json['refreshToken'] == null ? undefined : json['refreshToken'],
        'idToken': json['idToken'] == null ? undefined : json['idToken'],
        'newDeviceMetadata': json['newDeviceMetadata'] == null ? undefined : CognitoAuthenticationResultNewDeviceMetadataFromJSON(json['newDeviceMetadata']),
    };
}

export function CognitoAuthenticationResultToJSON(value?: CognitoAuthenticationResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accessToken': value['accessToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
        'refreshToken': value['refreshToken'],
        'idToken': value['idToken'],
        'newDeviceMetadata': CognitoAuthenticationResultNewDeviceMetadataToJSON(value['newDeviceMetadata']),
    };
}

